export const getParams = (param) => {
    const params = new URLSearchParams(location.search);
    
    return params.get(param)
}